
export default {
  data() {
    return {
      selectedTab: 0,
      plans: [
        {
          name: "general",
          title: "عمومی",
          child: [
            {
              name: "سپیدار",
              cpu: "4",
              ram: "4",
              disk: "50",
              price: "814,720",
              icon: "poplar.svg",
              alt: "طرح سپیدار - پیشنهاد خرید VPS",
              title: "طرح سپیدار - پیشنهاد خرید VPS",
            },
            {
              name: "کاج",
              cpu: "4",
              ram: "8",
              disk: "100",
              price: "1,221,491",
              icon: "pine.svg",
              alt: "طرح کاج- پیشنهاد خرید VPS",
              title: "ٓطرح کاج- پیشنهاد خرید VPS",
            },
            {
              name: "سرو",
              cpu: "8",
              ram: "8",
              disk: "100",
              price: "1,497,143",
              icon: "cedar.svg",
              alt: "طرح سرو- پیشنهاد خرید VPS",
              title: "ٓطرح سرو- پیشنهاد خرید VPS",
            },
            {
              name: "بید",
              cpu: "16",
              ram: "8",
              disk: "100",
              price: "2,017,819",
              icon: "Willow.svg",
              alt: "طرح بید- پیشنهاد خرید VPS",
              title: "ٓطرح بید- پیشنهاد خرید VPS",
            },
            {
              name: "افرا",
              cpu: "16",
              ram: "16",
              disk: "200",
              price: "2,810,442",
              icon: "Maple.svg",
              alt: "طرح افرا- پیشنهاد خرید VPS",
              title: "ٓطرح افرا- پیشنهاد خرید VPS",
            },
            {
              name: "راش",
              cpu: "16",
              ram: "32",
              disk: "400",
              price: "4,266,450",
              icon: "beech.svg",
              alt: "طرح راش- پیشنهاد خرید VPS",
              title: "ٓطرح راش- پیشنهاد خرید VPS",
            },
          ],
        },
        // {
        //   name: "storage",
        //   title: "ذخیره سازی",
        //   child: [
        //     {
        //       name: "g2-big",
        //       cpu: "1",
        //       ram: "1",
        //       disk: "25",
        //       price: "1,510,000",
        //     },
        //     {
        //       name: "g2-big",
        //       cpu: "1",
        //       ram: "1",
        //       disk: "25",
        //       price: "1,510,000",
        //     },
        //     {
        //       name: "g2-big",
        //       cpu: "1",
        //       ram: "1",
        //       disk: "25",
        //       price: "1,510,000",
        //     },
        //     {
        //       name: "g2-big",
        //       cpu: "1",
        //       ram: "1",
        //       disk: "25",
        //       price: "1,510,000",
        //     },
        //   ],
        // },
      ],
    };
  },
};
